<template>
  <section class="w-full flex justify-center mb-6">
    <div class="md:w-3/5 w11/12 relative">
      <div class="border-2 border-solid border-gray-300 border-opacity-30 p-3">
        <!-- LEFT SIDE -->
        <div v-if="isRight" class="flex justify-center items-center">
          <div class="md:w-1/12 hidden md:block"></div>
          <div class="w-3/5 flex flex-col justify-start items-start">
            <slot></slot>
          </div>
          <div class="w-2/5 flex justify-end">
            <img
              :src="require('@/assets/' + imageName + '')"
              alt=""
              class="w-3/4 aspect-auto image-shadow rounded-md"
            />
          </div>
        </div>
        <!-- RIGHT SIDE -->
        <div v-else class="flex justify-center items-center">
          <div class="w-2/5 flex justify-start">
            <img
              :src="require('@/assets/' + imageName + '')"
              alt=""
              class="w-3/4 aspect-auto image-shadow md:rounded-md rounded-sm"
            />
          </div>
          <div class="w-3/5 flex flex-col items-start">
            <slot></slot>
          </div>
          <div class="md:w-1/12 hidden md:block"></div>
        </div>
        <!-- Icons -->
        <div class="absolute top-2 left-2" :class="{ 'right-2': !isRight, 'text-right': !isRight }">
          <div class="relative w-full h-full hidden md:block">
            <div class="flex flex-col text-orange-300 text-xs">
              <div>
                <fa v-for="n in 5" :key="n" :icon="['far', 'star']"></fa>
              </div>
              <div v-for="n in 4" :key="n">
                <fa :icon="['far', 'star']"></fa>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Service-box-component',
  props: {
    isRight: {
      type: Boolean,
      default: false,
    },
    imageName: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped></style>
